import { Box, PrimaryButton, Typography } from "@crayon/design-system-react";
import MigratePartnerStepProps from "../MigratePartnerStepProps";

const WelcomeStep = ({ onStepComplete }: MigratePartnerStepProps) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    gap={1}
    mt={2}
  >
    <Typography variant="body1">
      Complete the partner migration wizard to move your settings to the Cloud-iQ source
    </Typography>
    <PrimaryButton onClick={onStepComplete} testId="begin-button">
      Begin
    </PrimaryButton>
  </Box>
);

export default WelcomeStep;
